import { IS_NEED_SHOW_LICENSES_MODAL, PERSISTED_LICENSES_KEY } from './licensesModalStorageKeys';
import { LicensesModalState } from './licensesModalReducer';

export const persistToEnableLicenses = (state: LicensesModalState) => {
  const persistedState = JSON.stringify(state);
  localStorage.setItem(PERSISTED_LICENSES_KEY, persistedState);
  localStorage.setItem(IS_NEED_SHOW_LICENSES_MODAL, 'true');
};
